import { render } from "./TextInputGroup.vue?vue&type=template&id=a9017696&lang=true"
import script from "./TextInputGroup.vue?vue&type=script&lang=js"
export * from "./TextInputGroup.vue?vue&type=script&lang=js"
script.render = render

export default script